import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import { devLog } from "utils/devLog";

const policyMap = new Map();
function DAAMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberRef);
  const [firstName, setFirstName] = useState(props.currState.MemberLookup.firstName || "");
  const [lastName, setLastName] = useState(props.currState.MemberLookup.lastName || "");
  const [phone, setPhone] = useState(props.currState.MemberLookup.phone || "");
  const [memberNumber, setMemberNumber] = useState(props.currState.MemberLookup.memberNumber || "");

  const [postalCode, setPostalCode] = useState(props.currState.MemberLookup.postalCode || "");

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [memberInfo, setMemberInfo] = useState(undefined);
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);
  const [createContacts, setCreateContact] = useState(["Create a new contact", ""]);

  const [checkDuplicateName, setCheckDuplicateName] = useState(false);
  const [partnerCode, setPartnerCode] = useState(props.currState.localGroup);

  useEffect(() => {
    onSubmit();
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
  }, []);

  useEffect(() => {
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
  }, [contacts]);

  // useEffect(() => {
  //   //devLog(props);
  //   onSubmit();
  //   setError("");
  // }, []);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
    }
  };

  const onMemberInfo = (memberInfo, contactInfo) => {
    if (typeof props.onMemberInfo === "function") {
      props.onMemberInfo(memberInfo, contactInfo);
    }
  };

  //select Contact function, set selectContact to contactInfo => input
  //
  const onSelect = (sc) => {
    setSelectedContact(sc);
    onMemberInfo(memberInfo, sc);
    //devLog("memberInfo", memberInfo.accountId);
    if (sc === undefined) {
      // //devLog(
      //   "selected undefined Contact: ",
      //   props.context.state.FirstName + " " + props.context.state.LastName
      // );
      setFirstName(props.context.state.FirstName);
      setLastName(props.context.state.LastName);
    } else {
      setFirstName(sc.firstName);
      setLastName(sc.lastName);
      // //devLog(
      //   "selected defined Contact: ",
      //   sc.firstName + " " + sc.lastName
      // );
    }
  };

  // const onSelectNewContact = (contactInfo) => {
  //   //devLog("selected Contact: ", contactInfo);
  //   setSelectedContact(
  //     props.currState.FirstName + " " + props.currState.LastName
  //   );
  //   //devLog("New Contact Name: ", selectedContact);
  //   onMemberInfo(memberInfo, contactInfo);
  // };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    //devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      onMemberInfo(policyMap.get(searchValue), selectedContact);
      setMemberInfo(policyMap.get(searchValue));
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        firstName: firstName,
        lastName: lastName,
        phone: phone,
        memberNumber: memberNumber,
        postalCode: postalCode,
        partnerCode: partnerCode,
        searchType: searchType,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        // //devLog("JSON", json);
        if (typeof json.data.memberInfo === "object" && typeof json.data.contactInfo === "object") {
          if (!json.data.error) {
            setContacts(json.data.contactInfo);
            onMemberInfo(json.data.memberInfo, selectedContact);
            setMemberInfo(json.data.memberInfo);
            onLoad(true);
          } else {
            setContacts([]);
            setMemberInfo([]);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setContacts([]);
          setMemberInfo([]);
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setContacts([]);
          setMemberInfo([]);
          setError(t("BWC.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        //devLog("error", e);
        setLoading(false);
        setContacts([]);
        setError(t("BWC.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = (e) => {
    e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const checkDuplicateContact = (firstName, lastName) => {
    contacts.map((con, index) => {
      if (
        con.firstName.toUpperCase().trim() === firstName?.toUpperCase().trim() &&
        con.lastName.toUpperCase().trim() === lastName?.toUpperCase().trim()
      ) {
        setCheckDuplicateName(true);
      }
      return checkDuplicateContact;
    });
  };

  return (
    <>
      <div className="formContainer">
        {memberInfo && !error ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.ContractInformationHeader2")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>{t("description.ConfirmCustomerName")}:</b> {memberInfo.accountName}
              </div>
              <hr />
              {/* <div className="policy-info-line">
                <b>{t("ATF.PolicyInformation.ConfirmCustomerMake")}</b>:{" "}
                {memberInfo.make}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("ATF.PolicyInformation.ConfirmCustomerModel")}</b>:{" "}
                {memberInfo.model}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("ATF.PolicyInformation.ConfirmCustomerLast8Vin")}</b>:{" "}
                {memberInfo.last8Vin}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("ATF.PolicyInformation.ConfirmCustomerVehicleWeight")}</b>
                : {memberInfo.vehicleWeight}
              </div>
              <hr /> */}
            </div>
          </div>
        ) : (
          <></>
        )}
        {contacts && !error ? (
          <div className="policyData">
            <div className="policyHeader">
              {contacts.length > 0 ? (
                <>
                  <h4>{t("description.ContactInformationHeader")}</h4>
                  <hr />
                </>
              ) : (
                <></>
              )}
              <>
                {contacts.map((contact, index) => {
                  return (
                    <div
                      key={index}
                      value={contact}
                      className={`vehicle-list-item ${selectedContact === contact ? "selected" : ""}`}
                      onClick={(e) => {
                        onSelect(contact);
                      }}
                    >
                      <div className="contact-list">
                        <input
                          className="vehicleSelector"
                          type="radio"
                          name="policy-vehicle"
                          checked={selectedContact === contact ? "selected" : ""}
                        />
                        <div value={contact} className="vehicle-list-item-col-1">
                          <h5 value={contact} className="name-h5">
                            {contact.firstName} {contact.lastName}
                          </h5>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {!checkDuplicateName ? (
                  <>
                    <hr />
                    <h4>{t("description.AddContactInformationHeader")}</h4>
                    <hr />
                    <div className="contact-list">
                      <input
                        className="vehicleSelector"
                        type="radio"
                        name="policy-vehicle"
                        checked={selectedContact === undefined}
                        onClick={(e) => {
                          // setSelectedContact(undefined);
                          onSelect(undefined);
                        }}
                      />
                      <div className="vehicle-list-item-col-1">
                        <h5 className="name-h5">
                          {props.currState.FirstName} {props.currState.LastName}
                        </h5>
                      </div>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      {error ? (
        <div className="errorSection">
          <b className="error">{error}</b>
          <div>
            <button className="ui-btn" onClick={onUserBack}>
              {t("description.TryAgain")}
            </button>
          </div>
        </div>
      ) : (
        <></>
      )}
      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}

export default DAAMemberInformationForm;
